import React from 'react';
import PropTypes from 'prop-types';

import NumberInputSelect from './NumberInputSelect';

import { formatMoney } from './formatHelpers'

const maxDropdownQuantity = 10;

class CartItem extends React.Component {
  constructor(props) {
    super(props);
    this.onQuantityChange = this.onQuantityChange.bind(this);
  }

  onQuantityChange(qty) {
    if (qty > 0) {
      this.props.onQuantityChange(this.props.item.Id, Number(qty));
    } else {
      this.props.onDelete(this.props.item.Id, this.props.item.Quantity);
    }
  }

  render() {
    const cartItem = this.props.item;
   
    return (
          <div className="panel panel-default" >
            <div className="panel-body">
              <div className="row">
                <div className="col-6">
                        <div className=" checkout-cart-item-name">
                            <h4 className="headline-xs"><b>{cartItem.Name}</b></h4></div>
                    <span className="checkout-cart-item-sku text-sm" style={{ marginRight: 10 }}>
                      {cartItem.DisplayName}
                    </span>
                  </div>
                  <div className="col-4" >
                    <div className="amount-cartitem subtitle-main text-sm" style={{ textAlign: "right" }} >
                      <span>{formatMoney('USD')(cartItem.Price)}</span>
                    </div>
                  </div>
                  <div className="col-2" >
                        <div className="delete-cartitem" style={{ textAlign: "right" }}  >
                      <a
                        href=""
                        className="vivid-orange"
                        onClick={(e) => {
                          e.preventDefault();
                          this.props.onDelete(cartItem.Id, cartItem.Quantity);
                        }}
                        style={{marginLeft: 10}}
                      >
                      <span className="fa fa-times"></span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
        </div>
    );
  }
}

CartItem.propTypes = {
  item: PropTypes.shape({
    Name: PropTypes.string.isRequired,
    ImageUrl: PropTypes.string.isRequired,
    SKU: PropTypes.string.isRequired,
    Quantity: PropTypes.number.isRequired
  }).isRequired,
  onQuantityChange: PropTypes.func.isRequired,
  onDelete: PropTypes.func
}

export default CartItem;


// WEBPACK FOOTER //
// ./src/Components/checkout/components/CartItem.jsx